import clsx from 'clsx';
import type { FC } from 'react';

import { OrgHubWordmark } from '../orghub-brand';
import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p>
        <OrgHubWordmark size={20} />
        {title}
      </p>
      <p>{subTitle}</p>
    </div>
  );
};
